import styled from 'styled-components/native';
import style from '../../../styles/index';
import { Picker as PickerComponent } from 'react-native-web';

export const Container = styled.View`
  flex-direction: row;
  justify-content: space-between;
  padding: 15px 0;
  border-bottom-width: 1px;
  border-bottom-color: #f0f0f0;
`;

export const PickerNameContainer = styled.View`
  flex-direction: row;
  flex: 1;
  align-items: flex-start;
`;

export const Picker = styled(PickerComponent)`
  background: ${style.colors.white};
  text-align: center;
  width: 55px;
  height: 35px;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  color: ${style.colors.black};
  font-family: ${style.fontName.ubuntuRegular};
  font-size: ${style.fonts.xsmall};
`;

export const NameContainer = styled.View`
  margin-left: 15px;
  flex: 1;
`;

export const Name = styled.Text`
  color: #333;
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.small};
  margin-bottom: 4px;
`;

export const PriceTitle = styled.Text`
  color: #666;
  font-family: ${style.fontName.ubuntuRegular};
  font-size: ${style.fonts.xxsmall};
`;

export const Price = styled.Text`
  color: ${props => props.theme.colors.primary};
  font-family: ${style.fontName.ubuntuBold};
  font-size: ${style.fonts.small};
  align-self: flex-start;
  margin-left: 10px;
`;

export const Separator = styled.View`
  display: none; 
`;
